import { Flex, Group } from '@byecode/ui'
import React from 'react'

import { PathParameter } from './PathParameter'
import { QueryParameter } from './QueryParameter'
import { State } from './State'
import { Variable } from './Variable'

export const PageParameterAndVariable: React.FC = () => {
    return (
        <Group label="数据">
            <Flex direction="column" gap={12} mt={8} px={8}>
                <PathParameter />
                <QueryParameter />
                <Variable />
                <State />
            </Flex>
        </Group>
    )
}
